(() => {
	angular
		.module('main')
		.directive('integrateWithQuickBooks', integrateWithQuickBooks);

	integrateWithQuickBooks.$inject = [
		'$location',
		'messageService',
		'randomStringGenerator',
		'integrationsDataService'
	];

	function integrateWithQuickBooks(
		$location,
		messageService,
		randomStringGenerator,
		integrationsDataService
	) {
		return {
			restrict: 'E',
			scope: {
				accountsQB: '<'
			},
			template: `
                   <div id="integrateWithQuickBooks" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <form class="form-horizontal form-group" role="form" ng-submit="saveQuickBooksSettings()">
                                    <div class="modal-header">
                                        <btn-close ng-click=changePathAfterIntegration()></btn-close>
                                        <h3 class="modal-title">QB integration settings</h3>
                                    </div>
                                    <div class="modal-body">
                                        <p class="f-s-15">Creating invoices in Studio Ninja will automatically copy them to your Quickbooks account.</p>
                                        <hr class="mb-30 mt-30">
                                        <div class="field-info">
                                            <h3 class="mb-30"> Default revenue account </h3>
                                            <p>Choose revenue account (we will copy your invoices to this account):</p>
        
                                            <div class="flex-row">
        
                                                <div class="select-style flex-grow-1">
                                                    <select ng-model="chosenAccount" required
                                                            ng-options="accountsQB as accountsQB.value for accountsQB in accountsQB.accounts | orderBy track by accountsQB.key">
                                                    </select>
                                                </div>
        
                                            </div>
                                        </div>
                                        <hr class="mb-30 mt-30">
        
                                        <div class="field-info">
                                            <h3 class="mb-30"> Default payment account </h3>
                                            
                                            <p> Choose payment account (all Studio Ninja payments will be applied to this account): </p>
                                            <div class="select-style flex-grow-1">
        
                                                <select ng-model="chosenTaxCodes" required
                                                        ng-options="accountsQB as accountsQB.value for accountsQB in accountsQB.taxCodes | orderBy track by accountsQB.key">
                                                </select>
        
                                            </div>
                                            <div class="checkbox-squared mt-30">
                                                <input type="checkbox" id="{{checkboxId}}" ng-model="isCheked" ng-change="qbcheck(isCheked)" />
                                                <label for="{{checkboxId}}"></label>
                                            </div>
                                            <label for="{{checkboxId}}"> Sync payments with Quickbooks </label>
                                            <div ng-show="isCheked" class="flex-row flex-wrap-xs warning-message m-0 mt-30">
                                                <img src="https://app.studioninja.co/build/release-pipeline-10/resources/dist/assets/images/icons/warning-sign-icon.png" class="warning-message__img" alt="warning-sign">
                                                <div class="warning-message__text mr-10">
                                                    <p>If you’re receiving payments via Stripe or PayPal and your Quickbooks account is connected to your bank feed, syncing payments with Quickbooks may cause the same payment to be recorded twice. To avoid recording the same payment twice, disable “sync payments with Quickbooks”.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="modal-footer modal-foot pb-30">
                                        <button class="btn btn-success btn-submit pull-left"
                                                type="submit"
                                                ng-disabled="button_disabled"
                                                ng-click="saveQuickBooksSettings()"
                                                spinning-wheel is-spinning-wheel-active="button_disabled"
                
                                        >Save settings
                                        </button>
                                        <button type="button" class="btn btn-lg btn-default ml-10"
                                                data-dismiss="modal"
                                                ng-click="changePathAfterIntegration()"
                                                ng-disabled="button_disabled"
                                        >Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				const integrateModal = '#integrateWithQuickBooks';

				const setQuickBooksAccounts = () => {
					const { accountId, taxCodeId, accounts, taxCodes } = scope.accountsQB;

					scope.chosenAccount = accountId
						? accounts.find(account => account.key === accountId)
						: accounts[0];

					scope.chosenTaxCodes = taxCodeId
						? taxCodes.find(account => account.key === taxCodeId)
						: taxCodes[0];
				};

				scope.$watch(
					'accountsQB',
					(newValue, oldValue) => {
						if (newValue && newValue !== oldValue) {
							console.log(newValue);
							setQuickBooksAccounts();
							scope.isCheked = newValue.paymentsEnabled;
						}
					},
					true
				);

				const successSetAccountQuickBook = () => {
					$(integrateModal).modal('hide');
					messageService.showToaster('s_2', 'qb');
				};

				const gatherData2Save = () => ({
					taxCodeId: scope.chosenTaxCodes.key,
					accountId: scope.chosenAccount.key,
					paymentsEnabled: scope.isCheked
				});

				scope.changePathAfterIntegration = () => {
					const path = $location.path();
					const pathWithoutQuick = path.replace('/qb', '');
					$location.url(pathWithoutQuick);
					scope.button_disabled = false;
				};

				scope.saveQuickBooksSettings = () => {
					scope.button_disabled = true;
					const data = gatherData2Save();
					const { accountId, taxCodeId } = scope.accountsQB;
					const isSettingsToUpdate = !!(accountId || taxCodeId);

					integrationsDataService
						.saveQuickbooksSettings(isSettingsToUpdate, data)
						.finally(() => scope.changePathAfterIntegration())
						.subscribe(
							() => successSetAccountQuickBook(),
							err => messageService.showDefaultErrorMessage(err)
						);
				};
				const checkboxIndex = randomStringGenerator.getMixedString();
				scope.checkboxId = `checkbox-squared-is-checked-${checkboxIndex}`;
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Integrations/integrateWithQuickBooks.js